import { serializeTokens } from 'config/constants/tokens'

const serializedTokens = serializeTokens()

// CRO
export const DEFAULT_INPUT_CURRENCY = 'CRO'
// USDC
export const DEFAULT_OUTPUT_CURRENCY = serializedTokens.usdc.address
